import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLikes = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 54.60029 54.59528",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "likes" }), /* @__PURE__ */ _jsx("path", {
		d: "M46.33787,28.24478a63.43879,63.43879,0,0,1-20.3342,20.052,1.03809,1.03809,0,0,1-1.04938-.00012A63.36594,63.36594,0,0,1,4.62766,28.24478C.58523,22.40827-.89313,10.47346,6.29852,5.20673c12.443-7.63056,19.18042,3.46494,19.18042,3.46494S32.21633-2.42383,44.667,5.20673C51.851,10.47346,50.3803,22.40827,46.33787,28.24478Z",
		style: {
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2.5px"
		}
	})]
});
export default SvgLikes;
